<template>
  <div class="card shadow-sm border-0">
    <div class="card-header">

      <h5 class="mb-0 text-primary">Record Supplier Transaction</h5>
    </div>
    <div class="card-body">
      <form @submit.prevent="saveTransaction">
        <div class="form-group" v-if="!purchaseId">
          <label>Purchase Order</label>
          <select class="form-control" v-model="form.purchase_id" required>
            <option value="null">Select Purchase</option>
            <option v-for="s in purchases" :key="s.id" :value="s.id">{{ s.purchase_order }}</option>
          </select>
        </div>

          <label>Date</label>
          <date-range-picker :auto-apply="autoApply" :single-date-picker=true v-model="form.datePicker" required class="custom-width-datepicker" />


        <div class="form-group">
          <label>Reference</label>
          <input type="text" class="form-control" v-model="form.reference" placeholder="Optional">
        </div>

        <div class="form-group">
          <label>Amount</label>
          <input type="number" step="0.01" class="form-control" v-model="form.amount" required>
        </div>

        <div class="form-group">
          <label class="font-weight-bold">Covered by</label>
          <div class="border rounded p-2">
            <div class="custom-control custom-radio mb-2">
              <input type="radio" id="spr-fs-pm" class="custom-control-input" value="payment_method" v-model="fundingSource">
              <label class="custom-control-label" for="spr-fs-pm">Business Payment Method</label>
            </div>
            <div class="custom-control custom-radio">
              <input type="radio" id="spr-fs-ext" class="custom-control-input" value="external" v-model="fundingSource">
              <label class="custom-control-label" for="spr-fs-ext">External Source</label>
            </div>
          </div>
        </div>

        <div class="form-group" v-if="fundingSource === 'payment_method'">
          <label>Payment Method Used</label>
          <select class="form-control" v-model="paymentTypeId">
            <option :value="null">Select payment method</option>
            <option v-for="pt in paymentTypes" :key="pt.id" :value="pt.id">{{ pt.payment_method }}</option>
          </select>
          <small class="text-muted">Cash is one of your configured payment methods above.</small>
        </div>

        <div class="form-group" v-if="fundingSource === 'external'">
          <label>Source Name</label>
          <input type="text" class="form-control" v-model="externalSourceLabel" placeholder="e.g. Director's Account" />
        </div>

        <button type="submit" class="btn btn-primary">
          <i class="fa fa-save"></i> Save Transaction
        </button>
      </form>
    </div>
  </div>
</template>

<script>
 import moment from "moment";
import DateRangePicker from "vue2-daterange-picker/src/components/DateRangePicker";
export default {
     name: "SupplierPaymentRecording",
components: {
    DateRangePicker

  },
  props: {
    // When set, skips the Purchase Order picker entirely and records against
    // this exact purchase (used when embedded from the Borrowed Stock
    // settlement page, where there's exactly one purchase to settle).
    purchaseId: { type: String, default: null },
    supplierId: { type: String, default: null },
    // Standalone /suppliers page usage (default) keeps its existing full-page
    // redirect on save. Embedded usage emits `saved` instead and resets the form.
    embedded: { type: Boolean, default: false },
  },
  data() {
    return {
      purchases: [],
      paymentTypes: [],
      fundingSource: 'payment_method',
      paymentTypeId: null,
      externalSourceLabel: '',
      form: {
        purchase_id: null,
        supplier_id: '',
        type: '',
        datePicker: {
                startDate: null,
            },
            date:'',
        reference: '',
        amount: ''
      },
      autoApply: true,
    append_to_body: true,
    datepicker_opens: 'right',
    ranges: false,
    }
  },
  created() {
    this.fetchPaymentTypes();

    if (this.purchaseId) {
      this.form.purchase_id = this.purchaseId;
      this.form.supplier_id = this.supplierId;
      return;
    }

    this.fetchPurchases();
  },

  computed: {
    // "Mode of Payment" used to be asked separately from "Covered by" - the
    // same question twice. Derive the legacy payment_method string from the
    // funding source instead of asking again. Cash isn't its own choice here -
    // it's just one of the company's configured Payment Methods, same as M-Pesa
    // or Bank, so there's no separate "Business Cash" option to collapse it into.
    derivedPaymentMethod() {
      if (this.fundingSource === 'external') {
        return this.externalSourceLabel || 'External';
      }
      const pt = this.paymentTypes.find(p => p.id === this.paymentTypeId);
      return pt ? pt.payment_method : 'Payment method';
    },
  },

  methods: {
    fetchPurchases() {

            const params = new URLSearchParams(window.location.search);
            this.form.supplier_id = this.supplierId || params.get('id')


      fetch(`/api/purchases?supplier_id=${this.form.supplier_id}`)
        .then(res => res.json())
        .then(data => {
          this.purchases = (data.purchases && data.purchases.data) || [];
        });
    },
    fetchPaymentTypes() {
      axios.get('/api/payments', { params: { enabled: true } })
        .then(({ data }) => {
          this.paymentTypes = Array.isArray(data) ? data.filter(p => p.enabled) : [];
        })
        .catch(() => {});
    },
    saveTransaction() {
         const urlParams = new URLSearchParams(window.location.search);

        this.form.date = moment(this.form.datePicker.startDate).format('YYYY-DD-MM')
      axios.post('/api/suppliers/transactions', {
        ...this.form,
        payment_method: this.derivedPaymentMethod,
        funding_source: this.fundingSource,
        payment_type_id: this.fundingSource === 'payment_method' ? this.paymentTypeId : null,
        external_source_label: this.fundingSource === 'external' ? this.externalSourceLabel : null,
      })
    .then(res => {

        this.form = { ...this.form, type: '', date: '', reference: '', amount: '' };
        this.fundingSource = 'payment_method';
        this.paymentTypeId = null;
        this.externalSourceLabel = '';

        if (this.embedded) {
          this.$emit('saved');
        } else {
          window.location.href=`/suppliers?id=${urlParams.get('id')}`
        }

      }).catch(err=>{
        this.$toasts && this.$toasts.push && this.$toasts.push({
            type: 'error',
            message: (err.response && err.response.data && err.response.data.message) || 'There was an error recording the payment',
        })
      });
    }
  }
}
</script>
